export const setAdminProfileData = (model, setModel, ele, property) =>{
    let newData = Object.assign({}, model);
    newData[property] = ele.target.value;
    console.log(newData);
    setModel(newData);
}